const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // If the env variable is set to a production URL, use it directly
  if (envUrl && !envUrl.includes("localhost") && !envUrl.includes("127.0.0.1")) {
    return envUrl;
  }
  
  // Try to dynamically resolve backend URL based on current hostname
  if (typeof window !== "undefined" && window.location) {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    
    // 1. Production domain detection - if user is visiting the live site,
    // we route to the Railway production backend URL.
    if (
      hostname === "codingcomet.in" || 
      hostname === "www.codingcomet.in"
    ) {
      return "https://web-production-c0e1d.up.railway.app";
    }
    
    // 2. If visiting via Render frontend domain (if any)
    if (hostname.endsWith("codingcomet.onrender.com")) {
      return "https://codingcomet.onrender.com";
    }
    
    // 3. Local network IP address detection (e.g. 192.168.x.x, 10.x.x.x, 172.x.x.x)
    if (
      hostname !== "localhost" && 
      hostname !== "127.0.0.1" && 
      /^(192\.168\.|10\.|172\.(1[6-9]|2[0-9]|3[0-1])\.|[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+)/.test(hostname)
    ) {
      return `${protocol}//${hostname}:8000`;
    }
  }
  
  // 4. Default fallback to whatever is in the env (which could be localhost) or local backend
  return envUrl || "http://localhost:8000";
};

export const BACKEND_URL = getBackendUrl();
